// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1Pl-m","emails":"CreateEditClinics_emails__2PyPZ","emailTagLabel":"CreateEditClinics_emailTagLabel__2fnnA"};